import React from "react";
import { MdLocationPin } from "react-icons/md";
import { MdEmail } from "react-icons/md";
import "./ContactInfo.scss";

const ContactIfo = () => {
  return (
    <div data-aos="fade-right" className="contact-info">
      <div className="lil-text">
        Contact <span>Me</span>
      </div>
      <div className="address">
        <MdLocationPin />
        <span>Baku, Azerbaijan</span>
      </div>
      {/* <div className="phone">
        <BsFillTelephoneFill />
        <a href="tel: +994 70 986 26 08">+994 70 986 26 08</a>
      </div> */}
      <div className="email">
        <MdEmail />
        <a href="mailto: lolaaskrova2@gmail.com">lolaaskrova2@gmail.com</a>
      </div>
    </div>
  );
};

export default ContactIfo;
